
import { useNavigate } from "react-router-dom";
import { Box, Card, CardMedia, Grid, Stack, Typography } from "@mui/material";
import { TooltipAndIcon } from "../../components";
import { separadorMillares, usePrecioCarritoXRole } from "../../../hooks";
import { eliminarItemCarrito } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthStore, useCarritoClienteStore } from "../../../stores";


import Swal from "sweetalert2";
const baseUrl = process.env.REACT_APP_API_URL;




export const CardsComprarAhoraCliente = ({ carritoCompra, urlCotiz }) => {

    
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { cliente } = useAuthStore();
    const { eliminarItem } = useCarritoClienteStore();
    const { precioUnidadSegunRol } = usePrecioCarritoXRole();


    // const handleModificarItem = async(item) => {
    //     const resp = await Swal.fire({
    //         title: 'Modificar Item',
    //         text: `¿Esta seguro de modifcar los valores de este item, cantidad, color, medidas etc..?`,
    //         icon: 'question',
    //         showCancelButton: true,
    //         confirmButtonText: 'Si' 
    //     });

    //     if(resp.value){
    //         setActivarProdUpdate(item);
    //         navigate(`/super/detproventa/${item.producto.categoria}/${item.producto._id }`);
    //     }
    // }


    const handleDetalleItem = (id) => {
        navigate(`/detalle-item/${id}`);
    }


    const handleDelete = async(id) => {
        const { value } = await Swal.fire({
            title: 'Eliminar Item Del Carrito',
            text: `¿Esta seguro de eliminar este item del carrito?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si' 
        });
        if( !value ) return;

        if( !cliente ){ eliminarItem(id); return; }

        const respuesta = await eliminarItemCarrito(id);
        if( respuesta ){ queryClient.invalidateQueries({ queryKey: ['carritoxuser'] }); }
    }


    return (

        <Grid container>
            <Box sx={{ width:'100%', mb:2, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
                    <Typography variant="h4" sx={{ fontSize: 22, fontWeight: 900 }}>
                        Items Disponibles
                    </Typography>
                </Box>
                {/* {(carritoCompra.length > 0 && usuarioVenta) && (
                    <Button color='secondary' variant="contained"size='small' onClick={ VerCotizacion }>
                        Ver Cotización
                    </Button>
                )} */}
            </Box>


            <Box sx={{ width: '100%', overflowX: { xs: 'auto', sm: 'auto', md: 'visible' } }}>
            <Stack spacing={2} direction="column" sx={{ minWidth: { xs:'700px', sm:'700px', md:'unset' }, width:'100%' }}>
                {carritoCompra.map(car => (
                    <Card key={car.id} sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', p:1, gap:1 }}>
                        <Box sx={{ width: { xs:'150px', md:'auto' }, minWidth: { xs:'150px', md:'100px' },flex:{md:'0 1 150px'}, 
                            display:'flex', justifyContent: 'center'
                        }}>
                            <CardMedia component="img"
                                sx={{ width:'100%', maxWidth:'140px', height:'100px', objectFit:'cover', borderRadius:3 }}
                                image={`${baseUrl}/uploads/productos/${car.producto.img}`}
                                alt="Imagen Item"
                            />
                        </Box>
                        
                        <Box sx={{ flex:{xs:'1 1 180px', md:'1 1 auto'}, minWidth:{xs:'150px', md:'120px'}, display:'flex', justifyContent:'center', px:1 }}>
                            <Typography variant="body1" sx={{textAlign:"center", fontSize:14, lineHeight:1}} >
                                {car.producto.nombre}
                            </Typography>
                        </Box>

                        <Box sx={{ width: { xs:'140px', md:'auto' }, minWidth: { xs:'140px', md:'120px' }, flex: { md:'0 1 140px' },
                            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5
                        }}>
                            <Typography variant="h6" sx={{ fontSize:'15px', lineHeight:1 }}>
                                {`$${separadorMillares(precioUnidadSegunRol(car) / car.cantidad)}`}
                            </Typography>

                            <Typography variant="h6" sx={{ fontSize:'15px' }}>
                                {`$${separadorMillares(precioUnidadSegunRol(car))}`}
                            </Typography>
                        </Box>

                        <Box sx={{ width: { xs:'100px', md:'auto' }, minWidth: {xs:'100px', md:'80px'}, 
                            flex:{md:'0 1 100px'}, display:'flex', flexDirection:'column', alignItems:'center'
                        }}>
                            <Typography variant="body2" sx={{lineHeight:1}}>Cantidad</Typography>
                            <Typography variant="body1" fontWeight="bold">
                                {car.cantidad}
                            </Typography>
                        </Box>

                        <Box sx={{ width:{ xs:'70px', md:'auto' }, minWidth:{ xs:'70px', md:'60px' }, flex: { md:'0 1 70px' }, 
                            display:'flex', justifyContent:'center'
                        }}>
                            <Stack spacing={0.5} direction="column" alignItems="center">
                                {/* <TooltipAndIcon
                                    titulo="Editar item"
                                    icono="editar"
                                    color="white"
                                    onClick={() => handleModificarItem(car)}
                                /> */}

                                <TooltipAndIcon
                                    titulo="Detalles del item"
                                    icono="ver"
                                    color="white"
                                    onClick={() => handleDetalleItem(car.id)}
                                />
                                <TooltipAndIcon
                                    titulo="Eliminar Item del Carrito"
                                    icono="eliminar"
                                    color="red"
                                    onClick={() => handleDelete(car.id)}
                                /> 
                            </Stack>
                        </Box>
                    </Card>
                ))}

            </Stack>
            </Box>
        </Grid>

    )
}
